import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CircleStateTrueActiveOnIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CircleStateTrueActiveOnIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 21.9995C6.48668 21.9995 2.00049 17.5133 2.00049 12C2.00049 6.48569 6.48618 1.99951 12 1.99951C17.5138 1.99951 22 6.4857 22 12C22 17.5133 17.5143 21.9995 12.0005 21.9995ZM10.5801 15.2642H10.5923C10.7915 15.2642 10.9829 15.1851 11.124 15.0435L16.128 10.0151C16.4199 9.7212 16.419 9.24659 16.125 8.9546C15.8325 8.6626 15.357 8.6626 15.0645 8.95655L10.6099 13.4331L8.95168 11.6558C8.66945 11.353 8.19435 11.3364 7.89162 11.6187C7.58889 11.9019 7.57229 12.3765 7.855 12.6792L10.044 15.0259C10.1826 15.1743 10.3765 15.2612 10.5801 15.2642Z"
        fill="#50D77A"
      />
    </svg>
  );
};

export default CircleStateTrueActiveOnIcon;
